import { createSelector } from 'reselect';
import PalletBoxUsageColumns from '../../containers/PalletBoxUsageColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.PALLET_BOX_USAGE_960.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PALLET_BOX_USAGE_960.isLoading;

export const getData =
  ReportDefinitions.PALLET_BOX_USAGE_960.getDataFunction();

export const getColumns =
  createSelector(getData, PalletBoxUsageColumns);
